export default __webpack_public_path__ + "static/wallet-72635a95204b2cbd9c0194ec759589c6.png";